<template>
  <div class="layout-default">
    <ListVideos />
    <PlayerVideos v-if="videoPlaying" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'VideosView',

  data () {
    return {}
  },

  computed: {
    ...mapState('global', ['isLoading']),
    ...mapState('auth', ['userProfile']),
    ...mapState('videos', ['videoPlaying'])
  },

  provide () {
    return {
      searchItems: this.searchItems
    }
  },

  methods: {
    ...mapMutations('auth', [
      'SET_IS_SIGN_IN',
      'SET_USER_PROFILE'
    ]),

    searchItems (items, query) {
      if (!items || !query) {
        return items
      }

      return items.filter(item => {
        return Object.values(item)
          .filter(item => typeof item !== 'boolean')
          .flat()
          .join(' ')
          .toLowerCase()
          .includes(query)
      })
    },

    signOut () {
      this.SET_IS_SIGN_IN(false)
      this.SET_USER_PROFILE(null)

      this.$router.push({ name: 'login' })
    }
  }
}
</script>
